export default class AnchorLinks {
    constructor(element) {
        this.container = element;
        this.sections = document.querySelectorAll('.section-marker');
        this.links = this.container.querySelectorAll('.sibling-links a');
        this.viewportCenter = window.innerHeight / 2;
        
        this.init();
    }

    init() {
        
		// Add scroll listener
        window.addEventListener('scroll', () => {
            this.checkActiveSection();
        });

        // Add click handlers to links
        this.links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = link.getAttribute('href').replace('#', '');
                const targetSection = document.getElementById(targetId);
                
                if (targetSection) {
                    const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
                    window.scrollTo({
                        top: targetPosition - this.viewportCenter,
                        behavior: 'smooth'
                    });
                }
            });
        });

        // Initial check
        this.checkActiveSection();
    }

    checkActiveSection() {
        let activeSection = null;
        let closestDistance = Infinity;

        // Find the closest section to viewport center
        this.sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            const distanceToCenter = Math.abs(rect.top - this.viewportCenter);
            
            if (distanceToCenter < closestDistance) {
                closestDistance = distanceToCenter;
                activeSection = section;
            }
        });

        if (activeSection) {
            this.updateActiveLink(activeSection.id);
        }
    }

    updateActiveLink(sectionId) {
        // Remove active class from all links
        this.links.forEach(link => {
            link.classList.remove('current');
        });

        // Add active class to corresponding link
        const activeLink = Array.from(this.links).find(
            link => link.getAttribute('href') === `#${sectionId}`
        );

        if (activeLink) {
            activeLink.classList.add('current');
        }
    }
}
